import React from 'react';
import { formatRelegationTitle } from '../utils/relegation';
import { useLanguage } from '../context/LanguageContext';
import './RelegationAlert.css';

// Значок релегации рядом со временем: "!" в кружке, как у контроля веса.
// Прибавленное время и причины — в подсказке: в протоколе рядом со временем
// лишняя цифра только мешает читать колонку.
const RelegationAlert = ({ entries }) => {
  const { t } = useLanguage();

  if (!entries || entries.length === 0) return null;

  const total = entries.reduce((sum, entry) => sum + entry.seconds, 0);
  if (total <= 0) return null;

  const title = formatRelegationTitle(entries, t);

  return (
    <span className="rider-relegation-alert" title={title} role="img" aria-label={title}>
      !
    </span>
  );
};

export default RelegationAlert;
